/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".immersion-tile[_ngcontent-%COMP%]{display:block;width:100%;padding:0;border:0;background:transparent;color:inherit;font:inherit;text-align:inherit;cursor:pointer}.green-background[_ngcontent-%COMP%]{background-color:#a0c13a!important}"];
export { styles as styles };
//# sourceMappingURL=immersion-tile.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/immersion-tile/immersion-tile.component.scss.shim.ngstyle.js
// module id = 1637
// module chunks = 27 28 29